export const puzzlePackTypesIds = {
  EMAG: 102,
}
